import VideoManagerContainer from "./VideoManagerContainer";

export default VideoManagerContainer;
